import { render, staticRenderFns } from "./imageCarousel.vue?vue&type=template&id=63154c4a&"
import script from "./imageCarousel.vue?vue&type=script&lang=js&"
export * from "./imageCarousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('63154c4a')) {
      api.createRecord('63154c4a', component.options)
    } else {
      api.reload('63154c4a', component.options)
    }
    module.hot.accept("./imageCarousel.vue?vue&type=template&id=63154c4a&", function () {
      api.rerender('63154c4a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2zuZ5sTfFgmsz/JS/imageCarousel.vue"
export default component.exports